import { render, staticRenderFns } from "./TamanioShowData.vue?vue&type=template&id=06f1b8fa&"
import script from "./TamanioShowData.vue?vue&type=script&lang=js&"
export * from "./TamanioShowData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports